import { FinanceRequestHistoryModel, FinanceRequestModel } from '../models/finance-request.model';
import {
  FinanceRequestHistoryUiModel,
  FinanceRequestUiModel
} from '../ui-models/finance-request.ui-model';

const date = (iso: string | null | undefined) => (iso ? new Date(iso) : undefined);

function mapHistory(entry: FinanceRequestHistoryModel): FinanceRequestHistoryUiModel {
  return {
    at: new Date(entry.at),
    by: entry.by || { userId: '', name: '' },
    step: entry.step,
    action: entry.action,
    comment: entry.comment || ''
  };
}

function mapToUI(model: FinanceRequestModel): FinanceRequestUiModel {
  const totals = model.totals || {};
  return {
    totals,
    id: model._id,
    type: model.type,
    serial: model.serial,
    status: model.status,
    employee: model.employee,
    manager: model.manager,
    form: model.form || { currency: 'EGP' },
    advances: model.advances || [],
    lines: model.lines || [],
    acknowledged: !!model.acknowledged,
    acknowledgedAt: date(model.acknowledgedAt),
    history: (model.history || []).map(mapHistory),
    ticketId: model.ticketId,
    submittedAt: date(model.submittedAt),
    updatedAt: date(model.updatedAt),
    amount: model.type === 'ADV' ? totals.requested || 0 : totals.balance || 0,
    advanceState: model.advanceState,
    settlements: model.settlements || [],
    canAct: !!model.canAct
  };
}

function mapToUIList(models: FinanceRequestModel[]): FinanceRequestUiModel[] {
  return (models || []).map(mapToUI);
}

export default { mapToUI, mapToUIList };
